import { act } from 'react';

export function TeamsIcon({ active }: { active?: boolean }) {
  return (
    <>
      {active ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.49935 1.6665C5.31602 1.6665 3.54102 3.4415 3.54102 5.62484C3.54102 7.7665 5.21602 9.49984 7.39935 9.57484C7.46602 9.5665 7.53268 9.5665 7.58268 9.57484C7.59935 9.57484 7.60768 9.57484 7.62435 9.57484C7.63268 9.57484 7.63268 9.57484 7.64102 9.57484C9.77435 9.49984 11.4493 7.7665 11.4577 5.62484C11.4577 3.4415 9.68268 1.6665 7.49935 1.6665Z"
            fill="#F7F7F7"
          />
          <path
            d="M11.7328 11.7919C9.40781 10.2419 5.61615 10.2419 3.27448 11.7919C2.21615 12.5002 1.63281 13.4586 1.63281 14.4836C1.63281 15.5086 2.21615 16.4586 3.26615 17.1586C4.43281 17.9419 5.96615 18.3336 7.49948 18.3336C9.03281 18.3336 10.5661 17.9419 11.7328 17.1586C12.7828 16.4502 13.3661 15.5002 13.3661 14.4669C13.3578 13.4419 12.7828 12.4919 11.7328 11.7919Z"
            fill="#7A7A7A"
          />
          <path
            d="M16.6578 6.11659C16.7911 7.73325 15.6411 9.14992 14.0495 9.34159C14.0411 9.34159 14.0411 9.34159 14.0328 9.34159H14.0078C13.9578 9.34159 13.9078 9.34159 13.8661 9.35825C13.0578 9.39992 12.3161 9.14159 11.7578 8.66659C12.6161 7.89992 13.1078 6.74992 13.0078 5.49992C12.9495 4.82492 12.7161 4.20825 12.3661 3.68325C12.6828 3.52492 13.0495 3.42492 13.4245 3.39159C15.0578 3.24992 16.5161 4.46659 16.6578 6.11659Z"
            fill="#F7F7F7"
          />
          <path
            d="M18.3249 13.8252C18.2582 14.6335 17.7415 15.3335 16.8749 15.8085C16.0415 16.2668 14.9915 16.4835 13.9499 16.4585C14.5499 15.9168 14.8999 15.2418 14.9665 14.5252C15.0499 13.4918 14.5582 12.5002 13.5749 11.7085C13.0165 11.2668 12.3665 10.9168 11.6582 10.6585C13.4999 10.1252 15.8165 10.4835 17.2415 11.6335C18.0082 12.2502 18.3999 13.0252 18.3249 13.8252Z"
            fill="#7A7A7A"
          />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.63216 9.05817C7.54883 9.04984 7.44883 9.04984 7.35716 9.05817C5.37383 8.9915 3.79883 7.3665 3.79883 5.3665C3.79883 3.32484 5.44883 1.6665 7.49883 1.6665C9.54049 1.6665 11.1988 3.32484 11.1988 5.3665C11.1905 7.3665 9.61549 8.9915 7.63216 9.05817Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.6747 3.3335C15.2914 3.3335 16.5914 4.64183 16.5914 6.25016C16.5914 7.82516 15.3414 9.1085 13.7831 9.16683C13.7164 9.1585 13.6414 9.1585 13.5664 9.16683"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.46563 12.1335C1.44896 13.4835 1.44896 15.6835 3.46563 17.0252C5.75729 18.5585 9.51563 18.5585 11.8073 17.0252C13.824 15.6752 13.824 13.4752 11.8073 12.1335C9.52396 10.6085 5.76562 10.6085 3.46563 12.1335Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.2832 16.6665C15.8832 16.5415 16.4499 16.2998 16.9165 15.9415C18.2165 14.9665 18.2165 13.3582 16.9165 12.3832C16.4582 12.0332 15.8999 11.7998 15.3082 11.6665"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}
    </>
  );
}

export function IntegrationsIcon({ active }: { active?: boolean }) {
  return (
    <>
      {active ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.99857 16.4577H7.76523C6.79857 16.4577 5.9569 15.8743 5.62357 14.9743C5.2819 14.0743 5.5319 13.0827 6.2569 12.441L12.9152 6.61602C13.3152 6.26602 13.3236 5.79102 13.2069 5.46602C13.0819 5.14102 12.7652 4.79102 12.2319 4.79102H9.99857C9.6569 4.79102 9.37357 4.50768 9.37357 4.16602C9.37357 3.82435 9.6569 3.54102 9.99857 3.54102H12.2319C13.1986 3.54102 14.0402 4.12435 14.3736 5.02435C14.7152 5.92435 14.4652 6.91602 13.7402 7.55768L7.0819 13.3827C6.6819 13.7327 6.67357 14.2077 6.79023 14.5327C6.91523 14.8577 7.2319 15.2077 7.76523 15.2077H9.99857C10.3402 15.2077 10.6236 15.491 10.6236 15.8327C10.6236 16.1743 10.3402 16.4577 9.99857 16.4577Z"
            fill="#F7F7F7"
          />
          <path
            d="M16.6667 12.5H14.1667C13.25 12.5 12.5 13.25 12.5 14.1667V16.6667C12.5 17.5833 13.25 18.3333 14.1667 18.3333H16.6667C17.5833 18.3333 18.3333 17.5833 18.3333 16.6667V14.1667C18.3333 13.25 17.5833 12.5 16.6667 12.5ZM15.425 16.25C14.9667 16.25 14.5917 15.875 14.5917 15.4167C14.5917 14.9583 14.9583 14.5833 15.425 14.5833H15.4333C15.8917 14.5833 16.2667 14.9583 16.2667 15.4167C16.2667 15.875 15.8917 16.25 15.425 16.25Z"
            fill="#F7F7F7"
          />
          <path
            d="M4.55729 1.66602C2.94896 1.66602 1.64062 2.97435 1.64062 4.58268C1.64062 6.19102 2.94896 7.49935 4.55729 7.49935C6.16562 7.49935 7.47396 6.19102 7.47396 4.58268C7.47396 2.97435 6.17396 1.66602 4.55729 1.66602ZM4.59063 5.41602C4.13229 5.41602 3.75729 5.04102 3.75729 4.58268C3.75729 4.12435 4.12396 3.74935 4.59063 3.74935H4.59896C5.05729 3.74935 5.43229 4.12435 5.43229 4.58268C5.43229 5.04102 5.05729 5.41602 4.59063 5.41602Z"
            fill="#F7F7F7"
          />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.55729 7.50033C6.16812 7.50033 7.47396 6.19449 7.47396 4.58366C7.47396 2.97283 6.16812 1.66699 4.55729 1.66699C2.94646 1.66699 1.64062 2.97283 1.64062 4.58366C1.64062 6.19449 2.94646 7.50033 4.55729 7.50033Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
          />
          <path
            d="M14.1413 12.5H16.6413C17.5579 12.5 18.3079 13.25 18.3079 14.1667V16.6667C18.3079 17.5833 17.5579 18.3333 16.6413 18.3333H14.1413C13.2246 18.3333 12.4746 17.5833 12.4746 16.6667V14.1667C12.4746 13.25 13.2246 12.5 14.1413 12.5Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
          />
          <path
            d="M9.99942 4.16699H12.2328C13.7744 4.16699 14.4911 6.07533 13.3328 7.09199L6.67443 12.917C5.51609 13.9253 6.23276 15.8337 7.76609 15.8337H9.99942"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.57111 4.58366H4.58074"
            stroke="#7A7A7A"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.4051 15.4167H15.4147"
            stroke="#7A7A7A"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}
    </>
  );
}

export function PlansIcon({ active }: { active?: boolean }) {
  return (
    <>
      {active ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.9758 5.53359C15.6174 3.72526 14.2758 2.93359 12.4091 2.93359H5.09245C2.89245 2.93359 1.42578 4.03359 1.42578 6.60026V10.8919C1.42578 12.7419 2.18411 13.8253 3.43411 14.2919C3.61745 14.3586 3.81745 14.4169 4.02578 14.4503C4.35911 14.5253 4.71745 14.5586 5.09245 14.5586H12.4174C14.6174 14.5586 16.0841 13.4586 16.0841 10.8919V6.60026C16.0841 6.20859 16.0508 5.85859 15.9758 5.53359ZM4.60911 10.0003C4.60911 10.3419 4.32578 10.6253 3.98411 10.6253C3.64245 10.6253 3.35911 10.3419 3.35911 10.0003V7.50026C3.35911 7.15859 3.64245 6.87526 3.98411 6.87526C4.32578 6.87526 4.60911 7.15859 4.60911 7.50026V10.0003ZM8.75078 10.9503C7.53411 10.9503 6.55078 9.96693 6.55078 8.75026C6.55078 7.53359 7.53411 6.55026 8.75078 6.55026C9.96745 6.55026 10.9508 7.53359 10.9508 8.75026C10.9508 9.96693 9.96745 10.9503 8.75078 10.9503ZM14.1341 10.0003C14.1341 10.3419 13.8508 10.6253 13.5091 10.6253C13.1674 10.6253 12.8841 10.3419 12.8841 10.0003V7.50026C12.8841 7.15859 13.1674 6.87526 13.5091 6.87526C13.8508 6.87526 14.1341 7.15859 14.1341 7.50026V10.0003Z"
            fill="#F7F7F7"
          />
          <path
            d="M18.5841 9.09958V13.3912C18.5841 15.9579 17.1174 17.0662 14.9091 17.0662H7.59245C6.96745 17.0662 6.40912 16.9746 5.92578 16.7912C5.53412 16.6496 5.19245 16.4412 4.91745 16.1746C4.76745 16.0329 4.88412 15.8079 5.09245 15.8079H12.4091C15.4924 15.8079 17.3258 13.9746 17.3258 10.8996V6.59958C17.3258 6.39958 17.5508 6.27458 17.6924 6.42458C18.2591 7.02458 18.5841 7.89958 18.5841 9.09958Z"
            fill="#F7F7F7"
          />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.0841 6.60023V10.8919C16.0841 13.4586 14.6174 14.5586 12.4174 14.5586H5.09244C4.71744 14.5586 4.35911 14.5253 4.02578 14.4503C3.81744 14.4169 3.61745 14.3586 3.43412 14.2919C2.18412 13.8253 1.42578 12.7419 1.42578 10.8919V6.60023C1.42578 4.03356 2.89244 2.93359 5.09244 2.93359H12.4174C14.2841 2.93359 15.6258 3.72526 15.9841 5.53359C16.0424 5.86692 16.0841 6.20856 16.0841 6.60023Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.5857 9.09984V13.3915C18.5857 15.9582 17.119 17.0582 14.919 17.0582H7.59401C6.97734 17.0582 6.41902 16.9749 5.93568 16.7915C4.94402 16.4249 4.26901 15.6665 4.02734 14.4499C4.36068 14.5249 4.71901 14.5582 5.09401 14.5582H12.419C14.619 14.5582 16.0857 13.4582 16.0857 10.8915V6.59984C16.0857 6.20818 16.0523 5.8582 15.9857 5.5332C17.569 5.86654 18.5857 6.98318 18.5857 9.09984Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.74884 10.9498C9.96387 10.9498 10.9489 9.96484 10.9489 8.74982C10.9489 7.53479 9.96387 6.5498 8.74884 6.5498C7.53381 6.5498 6.54883 7.53479 6.54883 8.74982C6.54883 9.96484 7.53381 10.9498 8.74884 10.9498Z"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.98438 6.91699V10.5837"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.5195 6.91699V10.5837"
            stroke="#7A7A7A"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}
    </>
  );
}
